import { useMediaQuery, useTheme } from "@material-ui/core";

const useBreakpoint = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  return { isMobile, isDesktop };
};

export default useBreakpoint;
